import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/pricing')({
  ssr: false, // CSR only - no SEO needed
})
